import React from 'react';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const InvoiceCompanySelect = ({ companies, loading, error, onRetry, value, onValueChange, editing = false }) => {
  const suffix = editing ? '-edit' : '';
  const id = `invoice-company${suffix}`;
  const unavailable = loading || Boolean(error) || companies.length === 0;
  const message = loading ? 'Caricamento società…' : error || (companies.length === 0 ? 'Nessuna società attiva disponibile.' : '');
  return (
    <div className="min-w-0">
      <Label htmlFor={id}>Società *</Label>
      <Select value={value} onValueChange={onValueChange} disabled={unavailable} required>
        <SelectTrigger id={id} data-testid={`company-select${suffix}`} aria-describedby={message ? `${id}-message` : undefined}>
          <SelectValue placeholder={loading ? 'Caricamento società…' : 'Seleziona società'} />
        </SelectTrigger>
        <SelectContent data-testid={`company-select-options${suffix}`}>
          {companies.map(company => (
            <SelectItem key={company.id} value={company.id} data-testid={`invoice-company-option${suffix}-${company.id}`}>
              {company.name} ({company.code})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {message && <p id={`${id}-message`} data-testid={`invoice-companies-message${suffix}`} role={error ? 'alert' : 'status'} className={`text-xs mt-1 ${error ? 'text-red-700' : 'text-slate-500'}`}>{message}</p>}
      {error && <Button type="button" variant="outline" size="sm" className="mt-2" data-testid={`invoice-companies-retry${suffix}`} onClick={onRetry}>Riprova caricamento società</Button>}
    </div>
  );
};